import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import IconButton from "@mui/material/IconButton";

function MealDialogEditPhotos({ isOpen, onClose, eventMeal, setEventMeal }) {

    function saveEventMealSettings() {

        onClose();

    }

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md">
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                Meal Photos
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent>


            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondary">Close</Button>
                <Button
                    onClick={saveEventMealSettings}
                    variant="contained"
                    color="primary"
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default MealDialogEditPhotos;